function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, `icon-close-checkbox`);

const SvgComponent = props => React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 9.42 10.03"
}, props), _ref, React.createElement("path", {
  d: "M.74,9.94l8.42-9M.74.91l8.42,9",
  transform: "translate(-0.24 -0.41)",
  style: {
    "fill": "none",
    "stroke": "#fff",
    "strokeLinecap": "round",
    "strokeLinejoin": "round"
  }
}));

export default __webpack_public_path__ + "static/media/icon-reject-checkbox.6faca4b3.svg";
export { SvgComponent as ReactComponent };